import { RouteRecordRaw } from "vue-router";

export const versions: RouteRecordRaw = {
  path: "/versions/require-update",
  name: "VersionsRequireUpdate",
  component: () =>
    import(
      /* webpackChunkName: "versions" */ "@/views/versions/RequireUpdate.vue"
    ),
  meta: {
    isBeforeLogin: true
  }
};
